<template lang="pug">
	#sfc-main-container
		sfc-sentry
		sfc-gtm-body
		sfc-dfp
		sfc-heap
		#sfc-main-content
			nuxt
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

</style>

<script>
export default {
	data(){
		return{
		}

	}
}
</script>
